import EventBus from 'eventing-bus';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import 'react-quill/dist/quill.snow.css';
import { Checkbox } from '@mui/material';
import Tabs from '@material-ui/core/Tabs';
import 'react-quill/dist/quill.bubble.css';
import 'react-phone-input-2/lib/style.css';
import AppBar from '@material-ui/core/AppBar';
import React, { useState, useEffect } from 'react';
import Typography from '@material-ui/core/Typography';
import { useSelector, useDispatch } from 'react-redux';
import 'react-accessible-accordion/dist/fancy-example.css';
import { TextField } from '@mui/material';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

import constants from '../../constants';
import { getProperties } from '../../store/Objects';
import AddObjectModal from '../Objects/AddObjectModal';
import { getSearchResults } from '../../store/Auth/index';
import { createRelation } from '../../store/Activities/index';

const RelationsModal = ({ setRelationsModal, objectType = 'contact', sourceObject }) => {

  const objectSchema = constants.getObjectSchema(objectType);

  const dispatch = useDispatch();
  const { searchResponse } = useSelector(state => state['Auth']);
  const { singlePageData } = useSelector(state => state['SinglePage']);
  const { properties } = useSelector(state => state['Objects'][objectSchema['type']]) || {};

  const [dropdowns, setDropdowns] = useState({});
  const [searchText, setSearchText] = useState('');
  const [selectedTab, setSelectedTab] = useState(1);
  const [selectedObjects, setSelectedObjects] = useState([]);
  const [existingObjects, setExistingObjects] = useState([]);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [alreadyAssociatedIds, setAlreadyAssociatedIds] = useState([]);

  console.log('*****objectSchema*****', objectSchema);
  console.log('*****sourceObject*****', sourceObject);
  console.log('*****objectType*****', objectType);
  console.log('*****singlePageData*****', singlePageData);
  console.log('*****properties*****', properties);

  useEffect(() => { dispatch(getProperties()) }, []);

  useEffect(() => {
    // Fetch properties for the object type

    // Fetch existing objects using getSearchResults
    const objectPlural = objectSchema?.['plural'] || objectType;
    dispatch(getSearchResults({ search: '', objects: [objectPlural] }));
    
    // Extract already associated object IDs from singlePageData
    if (singlePageData) {
      let associatedIds = [];
      if (objectType === 'contact' && singlePageData['contacts']) associatedIds = singlePageData['contacts'].map(contact => contact['_id']);
      else if (objectType === 'deal' && singlePageData['deals']) associatedIds = singlePageData['deals'].map(deal => deal['_id']);
      else if (objectType === 'company' && singlePageData['companies']) associatedIds = singlePageData['companies'].map(company => company['_id']);

      setSelectedObjects(associatedIds); // Pre-select already associated objects
      setAlreadyAssociatedIds(associatedIds);
      console.log('*****associatedIds*****', associatedIds);
    }
  }, [objectType, singlePageData]);

  useEffect(() => {
    if (searchResponse['results'] && searchResponse['results']?.[objectSchema['plural']])
      setExistingObjects(searchResponse['results'][objectSchema['plural']]);
    else setExistingObjects([]);
  }, [objectType, searchResponse]);

  useEffect(() => {
    // Debounced search
    const timer = setTimeout(() => dispatch(getSearchResults({ search: searchText, objects: [objectSchema['plural']] })), 500);
    return () => clearTimeout(timer);
  }, [searchText, objectType]);

  const toggleDropdownAction = (id) => setDropdowns((prev) => ({ ...prev, [id]: !prev[id] }));

  // Handle successful object creation
  const handleCreateSuccess = (newObject) => {
    // Create relation immediately
    if (newObject['_id'] && sourceObject) {
      const relationType = `${sourceObject['type']}_${objectType}`;
      dispatch(createRelation({ relationType, sourceId: sourceObject['id'], targetId: newObject['_id'], action: 'add' }));
    }
    setRelationsModal(false);
    setShowCreateModal(false);
  };
  
  const handleAddExisting = () => {
    // Relations are already created on checkbox click, just close the modal
    if (selectedObjects.length > 0)  EventBus.publish('success', `${selectedObjects.length} ${objectType}(s) linked successfully!`);
    setRelationsModal(false);
  }
  
  const renderCreateForm = () => {
    // Get the object schema
    const objectSchema = constants.objectsSchema[objectType] || {};
    return (
      <>
        <p style={{ padding: '20px', textAlign: 'center' }}>
          Click the button below to create a new {objectType}
        </p>
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <button className='btn-style-new' onClick={() => setShowCreateModal(true)}>
            Create New {objectSchema?.label || objectType}
          </button>
        </div>
      </>
    )
  }

  return (
    <>
      <aside className="deal-sidebar style-right-sidebar add-content accordian-tabs-area">
      <div className='top-header-area'>
        <h4>Add {objectType === 'contact' ? 'Contact' : objectType === 'deal' ? 'Deal' : 'Company'}</h4>
        <button className='close-btn-area' onClick={() => setRelationsModal(false)}>
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="path-1-inside-1_1678_4872" fill="white">
              <path d="M8.21204 0.303865C8.6172 -0.100965 9.28744 -0.101115 9.69251 0.303865C10.0977 0.709019 10.0977 1.38016 9.69251 1.78531L6.47962 4.9982L9.69251 8.21109C10.0977 8.61625 10.0977 9.28738 9.69251 9.69254C9.48301 9.902 9.21762 10.0001 8.95227 10.0002C8.68695 10.0002 8.42155 9.9019 8.21204 9.69254L4.99817 6.47867L1.78528 9.69254C1.58981 9.90197 1.31035 10 1.04504 10.0002C0.779599 10.0002 0.513396 9.9021 0.303834 9.69254C-0.101246 9.28738 -0.101295 8.61622 0.303834 8.21109L3.51672 4.9982L0.303834 1.78531C-0.101299 1.38018 -0.101257 0.709025 0.303834 0.303865C0.708987 -0.101288 1.38013 -0.101288 1.78528 0.303865L4.99817 3.51676L8.21204 0.303865Z" />
            </mask>
            <path d="M8.21204 0.303865C8.6172 -0.100965 9.28744 -0.101115 9.69251 0.303865C10.0977 0.709019 10.0977 1.38016 9.69251 1.78531L6.47962 4.9982L9.69251 8.21109C10.0977 8.61625 10.0977 9.28738 9.69251 9.69254C9.48301 9.902 9.21762 10.0001 8.95227 10.0002C8.68695 10.0002 8.42155 9.9019 8.21204 9.69254L4.99817 6.47867L1.78528 9.69254C1.58981 9.90197 1.31035 10 1.04504 10.0002C0.779599 10.0002 0.513396 9.9021 0.303834 9.69254C-0.101246 9.28738 -0.101295 8.61622 0.303834 8.21109L3.51672 4.9982L0.303834 1.78531C-0.101299 1.38018 -0.101257 0.709025 0.303834 0.303865C0.708987 -0.101288 1.38013 -0.101288 1.78528 0.303865L4.99817 3.51676L8.21204 0.303865Z" fill="var(--primary-color)" />
            <path d="M8.21204 0.303865L7.94019 0.0318008L7.94012 0.0318703L8.21204 0.303865ZM9.69251 0.303865L9.96446 0.0319116L9.96443 0.0318845L9.69251 0.303865ZM6.47962 4.9982L6.20766 4.72625L5.93571 4.9982L6.20766 5.27015L6.47962 4.9982ZM9.69251 9.69254L9.96444 9.96451L9.96446 9.96449L9.69251 9.69254ZM8.95227 10.0002V10.3848H8.95235L8.95227 10.0002ZM8.21204 9.69254L7.94008 9.96449L7.94018 9.96459L8.21204 9.69254ZM4.99817 6.47867L5.27012 6.20672L4.99813 5.93472L4.72617 6.20676L4.99817 6.47867ZM1.78528 9.69254L1.51312 9.42046L1.50411 9.43012L1.78528 9.69254ZM1.04504 10.0002V10.3848H1.04522L1.04504 10.0002ZM0.303834 9.69254L0.0318532 9.96446L0.0318803 9.96449L0.303834 9.69254ZM0.303834 8.21109L0.575787 8.48305L0.303834 8.21109ZM3.51672 4.9982L3.78868 5.27015L4.06063 4.9982L3.78868 4.72625L3.51672 4.9982ZM0.303834 0.303865L0.0318803 0.0319116L0.0318571 0.0319349L0.303834 0.303865ZM4.99817 3.51676L4.72622 3.78871L4.99813 4.06062L5.27008 3.78875L4.99817 3.51676ZM8.21204 0.303865L8.48388 0.575929C8.73895 0.321065 9.16579 0.321107 9.42058 0.575846L9.69251 0.303865L9.96443 0.0318845C9.4091 -0.523338 8.49544 -0.522995 7.94019 0.0318008L8.21204 0.303865ZM9.69251 0.303865L9.42055 0.575819C9.67551 0.830776 9.67551 1.2584 9.42055 1.51336L9.69251 1.78531L9.96446 2.05726C10.5198 1.50191 10.5198 0.587261 9.96446 0.0319116L9.69251 0.303865ZM9.69251 1.78531L9.42055 1.51336L6.20766 4.72625L6.47962 4.9982L6.75157 5.27015L9.96446 2.05726L9.69251 1.78531ZM6.47962 4.9982L6.20766 5.27015L9.42055 8.48305L9.69251 8.21109L9.96446 7.93914L6.75157 4.72625L6.47962 4.9982ZM9.69251 8.21109L9.42055 8.48305C9.67551 8.738 9.67551 9.16563 9.42055 9.42058L9.69251 9.69254L9.96446 9.96449C10.5198 9.40914 10.5198 8.49449 9.96446 7.93914L9.69251 8.21109ZM9.69251 9.69254L9.42057 9.42056C9.28679 9.55432 9.12078 9.61552 8.95219 9.61555L8.95227 10.0002L8.95235 10.3848C9.31445 10.3847 9.67923 10.2497 9.96444 9.96451L9.69251 9.69254ZM8.95227 10.0002V9.61555C8.7839 9.61555 8.61783 9.55432 8.48389 9.42048L8.21204 9.69254L7.94018 9.96459C8.22528 10.2495 8.58999 10.3848 8.95227 10.3848V10.0002ZM8.21204 9.69254L8.48399 9.42058L5.27012 6.20672L4.99817 6.47867L4.72622 6.75062L7.94008 9.96449L8.21204 9.69254ZM4.99817 6.47867L4.72617 6.20676L1.51328 9.42062L1.78528 9.69254L2.05727 9.96445L5.27016 6.75058L4.99817 6.47867ZM1.78528 9.69254L1.50411 9.43012C1.39292 9.54926 1.22188 9.61548 1.04487 9.61555L1.04504 10.0002L1.04522 10.3848C1.39881 10.3846 1.78669 10.2547 2.06644 9.95496L1.78528 9.69254ZM1.04504 10.0002V9.61555C0.876053 9.61555 0.709392 9.55419 0.575787 9.42058L0.303834 9.69254L0.0318803 9.96449C0.3174 10.25 0.683146 10.3848 1.04504 10.3848V10.0002ZM0.303834 9.69254L0.575814 9.42061C0.320867 9.16561 0.320881 8.73795 0.575787 8.48305L0.303834 8.21109L0.0318803 7.93914C-0.523471 8.49449 -0.52336 9.40914 0.0318532 9.96446L0.303834 9.69254ZM0.303834 8.21109L0.575787 8.48305L3.78868 5.27015L3.51672 4.9982L3.24477 4.72625L0.0318803 7.93914L0.303834 8.21109ZM3.51672 4.9982L3.78868 4.72625L0.575787 1.51336L0.303834 1.78531L0.0318803 2.05726L3.24477 5.27015L3.51672 4.9982ZM0.303834 1.78531L0.575787 1.51336C0.320873 1.25844 0.320862 0.830788 0.57581 0.575795L0.303834 0.303865L0.0318571 0.0319349C-0.523376 0.587263 -0.523471 1.50191 0.0318803 2.05726L0.303834 1.78531ZM0.303834 0.303865L0.575787 0.575819C0.830745 0.320861 1.25837 0.320861 1.51333 0.575819L1.78528 0.303865L2.05723 0.0319116C1.50188 -0.523438 0.58723 -0.523438 0.0318803 0.0319116L0.303834 0.303865ZM1.78528 0.303865L1.51333 0.575819L4.72622 3.78871L4.99817 3.51676L5.27012 3.2448L2.05723 0.0319116L1.78528 0.303865ZM4.99817 3.51676L5.27008 3.78875L8.48395 0.57586L8.21204 0.303865L7.94012 0.0318703L4.72626 3.24476L4.99817 3.51676Z" fill="white" mask="url(#path-1-inside-1_1678_4872)" />
          </svg>
        </button>
      </div>

      <div className='bottom-massage-box-area add-contect-modal-box'>
        <div className='tabs-area'>
          <div className='left-area'>
            <AppBar position="static">
              <Tabs value={selectedTab} onChange={(_, newValue) => setSelectedTab(newValue)} aria-label="simple tabs example">
                <Tab label="Create new" />
                <Tab label="Add existing" />
              </Tabs>
            </AppBar>
          </div>
        </div>
        <div className='tabs-content'>
          <TabPanel value={selectedTab} index={0}>
            <div className='filters-modal-content'>
              <div className='createdeal-form'> {renderCreateForm()} </div>
            </div>
          </TabPanel>
          <TabPanel value={selectedTab} index={1}>
            <div className='tabs-coontact'>
              <div className='searchbox'>
                <i className='icon'>
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_224_579)">
                      <path d="M17.8568 16.2345L13.203 11.5807C14.0782 10.377 14.5958 8.8965 14.5958 7.2975C14.5958 3.27375 11.322 0 7.2975 0C3.27375 0 0 3.27375 0 7.2975C0 11.322 3.27375 14.595 7.2975 14.595C8.823 14.595 10.2397 14.1247 11.4128 13.3215L16.0912 18L17.8568 16.2345ZM2.1405 7.2975C2.1405 4.4535 4.45425 2.13975 7.29825 2.13975C10.1423 2.13975 12.456 4.4535 12.456 7.2975C12.456 10.1415 10.1423 12.4552 7.29825 12.4552C4.4535 12.4552 2.1405 10.1415 2.1405 7.2975Z" fill="#89868D" />
                    </g>
                    <defs> <clipPath id="clip0_224_579"> <rect width="18" height="18" fill="white" /> </clipPath> </defs>
                  </svg>
                </i>
                <TextField
                  fullWidth
                  hiddenLabel
                  size="small"
                  variant="standard"
                  value={searchText}
                  placeholder={`Search ${objectType}s`}
                  onChange={(e) => setSearchText(e['target']['value'])}
                />
              </div>
              <div className='data-count-area'>
                <p>{existingObjects.length} {objectType}s</p>
                <Dropdown isOpen={dropdowns['defaultAdded'] || false} toggle={() => toggleDropdownAction('defaultAdded')} >
                  <DropdownToggle caret>
                    Defult (Recently added)
                    <i className="icon">
                      <svg width="5" height="4" viewBox="0 0 5 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.74219 2.40453L2.38875 0L0.385372 0C0.0425479 0 -0.128864 0.552327 0.113969 0.876105L1.96379 3.34253C2.26019 3.73773 2.74229 3.73773 3.03868 3.34253L3.74219 2.40453Z" fill="currentColor" />
                        <path d="M4.61365 0L2.38887 0L3.74231 2.40453L4.88863 0.876105C5.12789 0.552327 4.95648 0 4.61365 0Z" fill="currentColor" />
                      </svg>
                    </i>
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem>Recently added</DropdownItem>
                    <DropdownItem>Recently modified</DropdownItem>
                    <DropdownItem>A - Z</DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </div>
              <div className='companies-name'>
                <div className='compaies-data'>
                  <div className='comapny-box'>
                    {!Array.isArray(existingObjects) || existingObjects.length === 0 ? (
                      <p style={{ textAlign: 'center', padding: '20px' }}>No {objectType}s found</p>
                    ) : (
                      (Array.isArray(existingObjects) ? existingObjects : [])
                        .filter(obj => {
                          const searchLower = searchText.toLowerCase();
                          if (objectType === 'contact') return `${obj['firstName']} ${obj['lastName']} ${obj['email']}`.toLowerCase().includes(searchLower);
                          else if (objectType === 'deal') return obj['title']?.toLowerCase().includes(searchLower);
                          else if (objectType === 'company') return obj['name']?.toLowerCase().includes(searchLower);
                          return true;
                        })
                        .map(obj => {
                          const objectDisplay = objectType === 'contact' ? `${obj['firstName']} ${obj['lastName']} (${obj['email']})` : objectType === 'deal' ? obj['title'] : obj['name'];
                          return (
                            <label key={obj['_id']} style={{ display: 'block', marginBottom: '4px' }}>
                              <Checkbox checked={selectedObjects.includes(obj['_id'])} onChange={(e) => {
                                const isAlreadyAssociated = alreadyAssociatedIds.includes(obj['_id']);
                                
                                if (e['target']['checked']) {
                                  // Add to selected objects
                                  setSelectedObjects([...selectedObjects, obj['_id']]);
                                  
                                  // Only create relation if not already associated
                                  if (sourceObject && !isAlreadyAssociated) {
                                    const relationType = `${sourceObject['type']}_${objectType}`;
                                    dispatch(createRelation({ relationType, sourceId: sourceObject['id'], targetId: obj['_id'], action: 'add'  }));
                                  }
                                } else {
                                  // Remove from selected objects
                                  setSelectedObjects(selectedObjects.filter(id => id !== obj['_id']));
                                  
                                  // Remove relation
                                  if (sourceObject) {
                                    const relationType = `${sourceObject['type']}_${objectType}`;
                                    dispatch(createRelation({ relationType, sourceId: sourceObject['id'], targetId: obj['_id'], action: 'remove' }));
                                  }
                                }
                              }} />
                              {objectDisplay}
                            </label>
                          );
                        })
                    )}
                  </div>
                  <div className='group-form btn-groups' style={{ padding: '10px', borderTop: '1px solid #e0e0e0' }}>
                    <button 
                      type="button" 
                      className='btn-style-border' 
                      onClick={() => setRelationsModal(false)}
                    >
                      Cancel
                    </button>
                    <button 
                      type="button" 
                      className='btn-style-new'
                      onClick={handleAddExisting}
                      disabled={selectedObjects.length === 0}
                    >
                      Done
                    </button>
                  </div>
                  <div className='pagination-area'>
                    <ul className='pagination-modal'>
                      <li>
                        <button className='paginantion-arrow left-arrow'>
                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_1753_2254)">
                              <path d="M8.87555 9.5247L6.35655 7.0002L8.87555 4.4757L8.10005 3.7002L4.80005 7.0002L8.10005 10.3002L8.87555 9.5247Z" fill="var(--primary-color)" />
                            </g>
                            <defs>
                              <clipPath id="clip0_1753_2254">
                                <rect width="13.2" height="13.2" fill="white" transform="translate(0.399902 0.399902)" />
                              </clipPath>
                            </defs>
                          </svg>
                        </button>
                      </li>
                      <li>
                        <button className=''>1</button>
                      </li>
                      <li>
                        <button className='active'>2</button>
                      </li>
                      <li>
                        <button className=''>3</button>
                      </li>
                      <li>
                        ....
                      </li>
                      <li>
                        <button className=''>4</button>
                      </li>
                      <li>
                        <button className=''>5</button>
                      </li>
                      <li>
                        <button className='paginantion-arrow right-arrow'>
                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_1753_2732)">
                              <path d="M5.12451 9.5247L7.64351 7.0002L5.12451 4.4757L5.90001 3.7002L9.20001 7.0002L5.90001 10.3002L5.12451 9.5247Z" fill="var(--primary-color)" />
                            </g>
                            <defs>
                              <clipPath id="clip0_1753_2732">
                                <rect width="13.2" height="13.2" fill="white" transform="translate(0.399902 0.399902)" />
                              </clipPath>
                            </defs>
                          </svg>
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </TabPanel>
        </div>
      </div>
      </aside>
      
      {/* Add Object Modal */}
      {showCreateModal && (
        <AddObjectModal
          isOpen={showCreateModal}
          objectType={objectType}
          objectSchema={constants.objectsSchema[objectType] || {}}
          properties={properties}
          onClose={() => setShowCreateModal(false)}
          onSuccess={handleCreateSuccess}
        />
      )}
    </>
  );
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div role='tabpanel' hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other} >
      {value === index && <Box p={3}> <Typography>{children}</Typography> </Box>}
    </div>
  )
}

export default RelationsModal;